<script setup lang="ts">
defineProps<{
  eyebrow?: string
  n: string
  title: string
}>()
</script>

<template>
  <section class="mb-20">
    <div class="flex items-baseline gap-3 mb-6 flex-wrap">
      <SfgEyebrow>{{ n }}</SfgEyebrow>
      <span
        v-if="eyebrow"
        class="font-display uppercase text-eyebrow tracking-[0.18em] text-brand-ink/60"
      >
        {{ eyebrow }}
      </span>
    </div>
    <h2 class="font-editorial italic font-black text-display leading-none mb-10">
      {{ title }}
    </h2>
    <slot/>
  </section>
</template>
